import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col } from 'react-bootstrap';
import gql from 'graphql-tag';
import Pagination from '../../../components/stateful/Pagination';
import BlogEntry from '../../../components/stateless/BlogEntry/BlogEntry';

const PaginationButton = ({ children, eventKey, ...props }) => (
  <Button {...props} variant="default" className="color-primary-foreground" href="#" key={eventKey}>
    {children}
  </Button>
);

PaginationButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  eventKey: PropTypes.number,
};

PaginationButton.defaultProps = {
  className: undefined,
  children: undefined,
  eventKey: undefined,
};

const prepareState = ({ selectedCategory, categories, pageSlug }) => {
  const state = {
    page: 1,
    selectedCategory,
    perPage: 10,
  };
  if (categories) {
    categories.some((category) => {
      if (pageSlug === `blog/category/${category.slug}`) {
        state.selectedCategory = category.name;
        return true;
      }
      return false;
    });
  }
  return state;
};

class BlogHome extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    posts: PropTypes.arrayOf(PropTypes.shape({
      author: PropTypes.string,
      id: PropTypes.string.isRequired,
      snippet: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      category: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        slug: PropTypes.string,
      }),
      mediumId: PropTypes.string,
    })),
    categories: PropTypes.arrayOf(PropTypes.object),
    selectedCategory: PropTypes.string,
    pageSlug: PropTypes.string.isRequired,
  };

  static defaultProps = {
    title: undefined,
    posts: undefined,
    categories: [],
    selectedCategory: 'RECENT POSTS',
  };

  state = prepareState(this.props);

  onChangePerPage = ({ perPage, newPage }) => {
    this.setState({ perPage, page: newPage });
  };

  handlePageChange = (page) => {
    this.setState({ page });
  };

  filterPosts() {
    const { selectedCategory } = this.state;
    const { posts } = this.props;
    if (!posts) {
      return null;
    }

    return posts.filter((post) => {
      if (selectedCategory === 'RECENT POSTS' || post.category?.name === selectedCategory) {
        return true;
      }
      return false;
    });
  }

  renderPagination(posts) {
    const { page, perPage } = this.state;

    if (!posts || posts.length <= 10) {
      return null;
    }

    const paginationProps = {
      currentPageNumber: page,
      totalPages: Math.ceil(posts.length / perPage),
      onClick: this.handlePageChange,
      onChangePerPage: this.onChangePerPage,
      // TODO: translate 'posts'
      descriptor: 'posts',
      totalItems: posts.length,
      itemsPerPage: perPage,
    };

    return <Pagination {...paginationProps} />;
  }

  render() {
    const { title } = this.props;
    const { page, perPage } = this.state;
    const filteredPosts = this.filterPosts();
    const start = (page - 1) * perPage;
    const postsToDisplay = filteredPosts ? filteredPosts.slice(start, start + perPage) : false;

    /* eslint-disable react/no-array-index-key */
    return (
      <div>
        <Col md={12} sm={24}>
          <h1 className="color-primary-foreground">{title}</h1>
          <hr />
          {postsToDisplay && postsToDisplay.map((post, index) => (
            <div key={index}>
              <BlogEntry post={post} />
              <hr />
            </div>
          ))}
          {this.renderPagination(filteredPosts)}
        </Col>
      </div>
    );
    /* eslint-enable react/no-array-index-key */
  }
}


BlogHome.fragments = {
  settings: gql`
    fragment BlogHomeBlogSettings on Site {
      blogSettings{
        title
      }
    }
  `,
  posts: gql`
    fragment BlogHomeBlogPosts on BlogPost {
      title
      author
      category {
        id
        name
        slug
      }
      date
      slug
      snippet
      mediumId
    }
  `,
  categories: gql`
    fragment BlogHomeBlogCategories on BlogCategory {
      name
      slug
    }
  `,
};

export default BlogHome;
